<script>
  /**
   * color : primary, red, bleu, aqua, green, cyan, purple,pink
   */
  export let cardColor = "blue";
  export let cardTitle = "";
  export let cardSubTitle = "";
  export let cardFooterText = "";
  export let cardInfo = "";
  export let cardPourcent = 0;
</script>

<div class="col-sm-3">
  <div class="tile-progress tile-{cardColor}">
    <div class="tile-header">
      <h3>{cardTitle}</h3>
      <span>{cardSubTitle}</span>
    </div>
    <div class="tile-progressbar">
      <span data-fill="{cardPourcent}%" style="width: {cardPourcent}%;" />
    </div>
    <div class="tile-footer">
      <h4>
        <span class="pct-counter">{cardPourcent}</span>% {cardInfo}
      </h4>
      <span>{cardFooterText}</span>
    </div>
  </div>
</div>

<style>
  .tile-progress {
    background-color: #303641;
    color: #fff;
  }
  .tile-progress {
    background: #00a65b;
    color: #fff;
    margin-bottom: 20px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    background-clip: padding-box;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  .tile-progress .tile-header {
    padding: 15px 20px;
    padding-bottom: 40px;
  }
  .tile-progress .tile-progressbar {
    height: 2px;
    background: rgba(0, 0, 0, 0.18);
    margin: 0;
  }
  .tile-progress .tile-progressbar span {
    background: #fff;
  }
  .tile-progress .tile-progressbar span {
    display: block;
    background: #fff;
    width: 0;
    height: 100%;
    -webkit-transition: all 1.5s cubic-bezier(0.23, 1, 0.32, 1);
    -moz-transition: all 1.5s cubic-bezier(0.23, 1, 0.32, 1);
    -o-transition: all 1.5s cubic-bezier(0.23, 1, 0.32, 1);
    transition: all 1.5s cubic-bezier(0.23, 1, 0.32, 1);
  }
  .tile-progress .tile-footer {
    padding: 20px;
    text-align: right;
    background: rgba(0, 0, 0, 0.1);
    -webkit-border-radius: 0 0 3px 3px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 0 0 3px 3px;
    -moz-background-clip: padding;
    border-radius: 0 0 3px 3px;
    background-clip: padding-box;
    -webkit-border-radius: 0 0 3px 3px;
    -moz-border-radius: 0 0 3px 3px;
    border-radius: 0 0 3px 3px;
  }
  .tile-progress.tile-red {
    background-color: #f56954;
    color: #fff;
  }
  .tile-progress {
    background-color: #303641;
    color: #fff;
  }
  .tile-progress.tile-blue {
    background-color: #0073b7;
    color: #fff;
  }
  .tile-progress.tile-aqua {
    background-color: #00c0ef;
    color: #fff;
  }
  .tile-progress.tile-green {
    background-color: #00a65a;
    color: #fff;
  }
  .tile-progress.tile-cyan {
    background-color: #00b29e;
    color: #fff;
  }
  .tile-progress.tile-purple {
    background-color: #ba79cb;
    color: #fff;
  }
  .tile-progress.tile-pink {
    background-color: #ec3b83;
    color: #fff;
  }
</style>
